import init from '../../../js/init';

const name = 'page-modal';
const selector = '.page-modal';
const cookie_prefix = 'dismiss_modal_';

init(Drupal, name, selector, root => {
  const modalId = root.id;
  const event = root.dataset.event;
  const delay = root.dataset.delay ? root.dataset.delay : 0;
  const selector = root.dataset.selector;
  const recurrency = root.dataset.recurrency;
  const modal = root.querySelector('.modal');
  const element = event == 'load' ? window : document.querySelector(selector ? selector : 'body');
  element.addEventListener(event, () => {
    setTimeout(() => {
      if (getCookie(modalId) !== null) {
        return;
      }
      modal.classList.toggle('modal--visible');
      modal.classList.toggle('modal--fade');

      let cookie_expires = new Date();
      switch (recurrency.toString()) {
        case '-1':
          cookie_expires.setFullYear(cookie_expires.getFullYear() + 10);
          break;
        case '0':
          cookie_expires.setFullYear(cookie_expires.getFullYear() + -1);
          break;
        default:
          const days = parseInt(recurrency, 10);
          cookie_expires.setDate(cookie_expires.getDate() + days);
          break
      }
      setCookie(modalId, cookie_expires.toUTCString());
    }, delay * 1000);
  });

  const setCookie = (id, expire_date) => {
    document.cookie = cookie_prefix + id + "=1; path=/" + (expire_date ? "; expires=" + expire_date : "");
  }
  
  const getCookie = (id) => {
    const nameEQ = cookie_prefix + id + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

});
